import { z } from "zod";

/**
 * Konfigurace Google Places API — živé hodnocení a počet recenzí na
 * veřejném webu. Klíč i Place ID se zadávají v Administraci → Nástroje.
 *
 * `apiKey` je volitelný: na rozdíl od OAuth páru není klíč u Googlu vázaný
 * na konkrétní místo, takže změna Place ID smí podržet stávající uložený
 * klíč. Prázdný string z formuláře se mapuje na `undefined` (vzor
 * setGoogleSyncConfigSchema) — server pak podrží uloženou hodnotu; když
 * žádná uložená není, vrátí BAD_REQUEST.
 */
/**
 * Jen tisknutelné ASCII bez mezer — klíč jde do HTTP hlavičky a řídicí znak
 * (CR/LF z kopírování) by způsobil chybu, která celou hodnotu vypíše do logu.
 */
const BEZ_BILYCH_ZNAKU = /^[\x21-\x7E]+$/;

export const setGooglePlacesConfigSchema = z.object({
  placeId: z
    .string()
    .trim()
    .min(1, "Vyplňte Place ID")
    .max(300, "Place ID může mít nejvýše 300 znaků")
    .regex(BEZ_BILYCH_ZNAKU, "Place ID nesmí obsahovat mezery ani zalomení řádku"),
  apiKey: z
    .string()
    .trim()
    .max(200, "API klíč může mít nejvýše 200 znaků")
    .refine((v) => v === "" || BEZ_BILYCH_ZNAKU.test(v), {
      message: "API klíč nesmí obsahovat mezery ani zalomení řádku",
    })
    .optional()
    .transform((v) => (v ? v : undefined)),
});

export type SetGooglePlacesConfigInput = z.infer<typeof setGooglePlacesConfigSchema>;
